import { gql } from '@apollo/client';

import { CartPageFragment } from '../components/CartPage/cartPageFragments.gql';

export const ADD_CONFIGURATOR_MUTATION = gql`
    mutation addSimpleProductToCart(
        $cartId: String!
        $quantity: Float!
        $sku: String!
        $customPrice: Float!
        $customOptionId: Int!
        $customOptionValue: String!
    ) {
        addSimpleProductsToCart(
            input: {
                cart_id: $cartId
                cart_items: [
                    {
                        data: {
                            quantity: $quantity
                            sku: $sku
                            custom_price: $customPrice
                        }
                        customizable_options: {
                            id: $customOptionId
                            value_string: $customOptionValue
                        }
                    }
                ]
            }
        ) @connection(key: "addSimpleProductsToCart") {
            cart {
                id
                ...CartPageFragment
            }
        }
    }
    ${CartPageFragment}
`;
